export default {
  execute(input) {
    return input.objects;
  }
}


// WEBPACK FOOTER //
// ./src/services/SortService.js